import { showOnlyRegulationsWithNumericalStandardsClicked } from "../../actions/filters";

import { connect } from "react-redux";

import CheckBox from "../../../../shared_components/check_box";

const mapStateToProps = (state) => {
  const value = "ignore";
  const checked = state.filters.showOnlyRegulationsWithNumericalStandards == "checked";
  const title = "Show only regulations with numerical standards";
  const extraHtmlClasses = { "col-md-6": true };

  return { value, checked, title, extraHtmlClasses };
};

const mapDispatchToProps = dispatch => ({
  onClick: () => { dispatch(showOnlyRegulationsWithNumericalStandardsClicked()); }
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckBox);
